import { render, staticRenderFns } from "./HeaderPublic.vue?vue&type=template&id=23c2f7d9&scoped=true"
import script from "./HeaderPublic.vue?vue&type=script&lang=js"
export * from "./HeaderPublic.vue?vue&type=script&lang=js"
import style0 from "./HeaderPublic.vue?vue&type=style&index=0&id=23c2f7d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2f7d9",
  null
  
)

export default component.exports